import './EventVideoThumbnail.scss';
import { AdminEventPlayerType } from 'types/admin/trackmanEventsAdmin';
import { ReactComponent as PlayButtonIcon } from 'images/icons/PlayButton.svg';
import { Badge } from 'components/Badge/Badge';

export const EventVideoThumbnail = ({
  videoId,
  thumbnailSize,
  badgeText,
  badgeIcon,
  playerType,
}: {
  videoId: string;
  thumbnailSize: string;
  badgeText?: string;
  badgeIcon?: React.ReactNode;
  playerType: AdminEventPlayerType;
}) => {
  const src =
    playerType === 'Youtube' ? `https://img.youtube.com/vi/${videoId}/${thumbnailSize}.jpg` : `https://vumbnail.com/${videoId}.jpg`;
  return (
    <div className='video-item'>
      <div className='thumbnail-wrapper'>
        <img src={src} alt='Video thumbnail' />
        <span className='play-icon'>
          <PlayButtonIcon />
        </span>
        {badgeText && (
          <div className='badge-container'>
            <Badge badgeText={badgeText} badgeIcon={badgeIcon} className='badge--brandOrange' />
          </div>
        )}
      </div>
    </div>
  );
};
